// @ts-nocheck
import React from "react";
import useAccount from "classes/Accounts/hooks/useAccount";
import CustomAsyncSelect from "components/Inputs/CustomAsyncSelect/CustomAsyncSelect";
import { t } from "i18next";

function GroupOptionsStep(props) {
	const group = props.object;
	const {account} = useAccount();

	return (
		<div className="inner-step-cont d-flex flex-column">
			<div className="mb-2">{ t("Groups.DUP_POSTS") }</div>
			<CustomAsyncSelect
				url={"groups/company/" + account.companyId}
				isMulti={true}
				timeout={0}
				treat={(a) => {
					return ({
						label: a.groupName,
						value: a.id
					});
				}}
				onSelect={(items) => {
					if (items.length)
						group.setDupGroups(items.map((a) => a.value));
					else
						group.setDupGroups([]);
				}}
			/>
		</div>
	);
}

export default GroupOptionsStep;
